import React, {useEffect, useRef, useState} from 'react';
import {Check} from "react-feather";

const SelectDropdown = ({ready = true, items, activeFilter, onSelect, buttonClass = '', contentClass = ''}) => {
    const [isOpen, setIsOpen] = useState(false);

    const dropdownRef = useRef();
    useEffect(() => {
        let handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleSelect = (item) => {
        onSelect(item);
        setIsOpen(false);
    };

    return (
        <div className="sl-flex " ref={dropdownRef}>
            <div className="select sl-w-full">
                <button disabled={!ready}
                        className={`select-dropdown sl-cursor-pointer sl-w-full sl-flex sl-justify-between sl-align-center sl-gap-2 ${!buttonClass ? 'sl-bg-white sl-shadow-xs' : ''}  sl-py-10 sl-px-14 sl-border sl-border-solid sl-border-gray-300 sl-rounded-lg sl-rounded-lg ${isOpen ? 'active' : ''} ${buttonClass}`}
                        onClick={handleToggle}>
                    {activeFilter && activeFilter.text}
                </button>
                {isOpen && (
                    <div
                        className={`${contentClass} select-options sl-flex sl-flex-col sl-absolute sl-top-13 sl-right-0 sl-left-0 sl-shadow-lg sl-bg-white sl-border sl-border-solid sl-border-gray-100 sl-rounded-lg`}>
                        {items.map((item, index) => (
                            <div
                                key={index}
                                rel={item.key}
                                className="sl-flex sl-justify-between sl-gap-2 sl-text-gray-900 sl-py-10 sl-px-14"
                                onClick={() => handleSelect(item)}>
                                {item.text}
                                {item.key === activeFilter.key && <Check className="sl-text-primary-600"/>}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelectDropdown;
